/**
 * Tokens preluați 1:1 din design (`Valori Meteo MUI` — variabilele `--m-*`).
 * Sunt singura sursă de adevăr pentru culori; nu hardcoda hex-uri în componente,
 * folosește `theme.palette.weather.*`.
 */
export interface WeatherTokens {
  bg: string;
  surface: string;
  ink: string;
  soft: string;
  faint: string;
  line: string;
  accent: string;
  accentSoft: string;
  /** Verde de „recepție normală” — singurul semnal non-accent din design. */
  ok: string;
}

export interface SoftShadows {
  card: string;
  cardRaised: string;
}

export const lightTokens: WeatherTokens = {
  bg: '#f4f4f5',
  surface: '#ffffff',
  ink: '#201e1d',
  soft: '#6b6867',
  faint: '#9b9797',
  line: '#eae7e7',
  accent: '#dd2b0f',
  accentSoft: '#ffe0d9',
  ok: '#3ea76a',
};

export const darkTokens: WeatherTokens = {
  bg: '#121212',
  surface: '#1c1c1e',
  ink: '#f3f1f0',
  soft: '#a5a1a0',
  faint: '#6f6b6a',
  line: '#2c2c2e',
  accent: '#ff7a63',
  accentSoft: '#3a201b',
  ok: '#4cc182',
};

export const lightShadows: SoftShadows = {
  card: '0 1px 2px rgba(32,30,29,.06), 0 8px 24px rgba(32,30,29,.06)',
  cardRaised: '0 2px 6px rgba(32,30,29,.08), 0 18px 40px rgba(32,30,29,.10)',
};

export const darkShadows: SoftShadows = {
  card: '0 1px 2px rgba(0,0,0,.5), 0 10px 30px rgba(0,0,0,.4)',
  cardRaised: '0 2px 8px rgba(0,0,0,.55), 0 22px 48px rgba(0,0,0,.5)',
};

/** Raze folosite de design: carduri, tile-uri interne, pilule. */
export const radii = {
  card: 18,
  tile: 12,
  pill: 999,
} as const;

export const fontFamily = '"Archivo Variable", "Archivo", system-ui, -apple-system, sans-serif';
